/* eslint-disable react/jsx-key */
import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { Checkbox, Col, Radio, RadioChangeEvent, Row, Space, Transfer } from 'antd'
import styled from 'styled-components'
import { AppInput, AppTextArea } from 'Components/form'
import { Theme } from 'Components/common'
import { getProductGrnListAPI, updateStockAPI } from 'Store/stock/api'
import { GrnByProductListReq, StockListData, UpdateStockReq } from 'Store/stock/types'
import { selectCurrentUser } from 'Store/user/selector'
import { selectProductGrnList, selectStockActionEvent } from 'Store/stock/selector'
import { PrimaryButton } from 'Components/button'
import { cloneDeep } from 'lodash'
import { formValidation, isFormError, isFormRequired } from 'helpers/format'
import { ConfirmDailog, EventModal } from 'Components/modal'
import { getUserLogin } from 'helpers/account'
import { clearEventAction } from 'Store/stock/actions'
import { CheckboxChangeEvent } from 'antd/lib/checkbox'

type Props = ReduxProps & {
  data?: StockListData
  onCloseDrawer: () => void
  onSuccess: () => void
}

const AdjustStockForm: React.FunctionComponent<Props> = props => {
  const { data, currentUser, productGrn, onCloseDrawer, onSuccess, actionEvent } = props
  const uom = data?.uom || ''

  const initForm = {
    adjustAmount: 0,
    reason: '',
  }

  const requireFeild = ['adjustAmount', 'reason']
  const [formData, setFormData] = useState(cloneDeep(initForm))
  const [targetKeys, setTargetKeys] = useState([] as any[])
  const [selectedKeys, setSelectedKeys] = useState([] as any[])
  const [formError, setFormError] = useState([] as string[])
  const [confirmDialog, setConfirmDialog] = useState(false)
  const [autoStock, setAutoStock] = useState(true)
  const userInfo = getUserLogin()
  const dispatch = useDispatch()

  const onGetProductGrn = (): void => {
    const req: GrnByProductListReq = {
      product_id: data?.product_id || 0,
      product_option_id: data?.product_option_id || 0,
    }
    dispatch(getProductGrnListAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  useEffect(() => {
    onGetProductGrn()
    setAutoStock(true)
  }, [data, data?.quantity_all])

  useEffect(() => {
    setTargetKeys([])
    setFormData(cloneDeep(initForm))
  }, [productGrn])

  const onSave = (): void => {
    if (!validateForm()) return
    const req: UpdateStockReq = {
      grn_item_ids: targetKeys,
      quantity: formData.adjustAmount,
      reason: formData.reason,
      username: userInfo?.username || '',
    }
    dispatch(updateStockAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  useEffect(() => {
    setAutoStock(true)
  }, [productGrn])

  useEffect(() => {
    if (autoStock) {
      onClickAuto()
    }
    if (!autoStock) {
      setTargetKeys([])
    }
  }, [formData.adjustAmount, autoStock])

  const onClickAuto = () => {
    if (!formData.adjustAmount) {
      setTargetKeys([])
      return
    }
    let count = 0
    const target = [] as any[]
    productGrn &&
      productGrn.forEach(grn => {
        if (count > formData.adjustAmount || formData.adjustAmount <= 0) return
        if (grn.item.amount_system > 0) {
          target.push(grn.item.id)
          count += grn.item.amount_system
        }
      })
    setTargetKeys(target)
  }

  const onClickSave = (): void => {
    if (!validateForm()) return
    setConfirmDialog(true)
  }

  const onUpdateData = (val: string, key: string) => {
    if (key === 'adjustAmount') {
      let amt = parseInt(val)
      if (amt > (data?.quantity_all || 0)) {
        amt = data?.quantity_all || 0
      }
      setFormData({
        ...formData,
        adjustAmount: amt,
      })
    } else {
      setFormData({
        ...formData,
        [key]: val,
      })
    }
  }

  const validateForm = () => {
    const error = formValidation(requireFeild, formData)
    const grnCount = countTarget()
    if (grnCount < formData.adjustAmount) {
      error.push('grn')
    }
    setFormError([...error])
    return error.length > 0 ? false : true
  }

  useEffect(() => {
    onGetProductGrn()
    setFormError([])
  }, [data?.product_option_id])

  useEffect(() => {
    if (formError.length > 0) {
      validateForm()
    }
  }, [formData])

  const getData = () => {
    const datasource = [] as {
      key: any
      title: string
      description: string
    }[]
    productGrn &&
      productGrn.forEach(data => {
        datasource.push({
          key: data.item.id,
          title: data.grn_no,
          description: `(คงเหลือ ${data.item.amount_system} ${data.item.product_uom_system})`,
        })
      })
    return datasource
  }

  const onChange = (nextTargetKeys: any) => {
    setTargetKeys(nextTargetKeys)
  }

  const onSelectChange = (sourceSelectedKeys: any, targetSelectedKeys: any) => {
    setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys])
  }

  const onScroll = () => {}

  const countTarget = () => {
    let count = 0
    targetKeys.forEach(target => {
      productGrn &&
        productGrn.forEach(grn => {
          if (target === grn.item.id) {
            count += grn?.item.amount_system
          }
        })
    })
    return count
  }

  const isRequired = (name: string) => {
    return isFormRequired(requireFeild, name)
  }

  const isError = (name: string) => {
    return isFormError(formError, name)
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onEventSuccess = (): void => {
    setConfirmDialog(false)
    clearEvent()
    setTargetKeys([])
    onSuccess()
  }

  const grnCount = countTarget()

  const FooterContent = (
    <Row justify="center">
      <Col>
        <Space size="middle" align="baseline">
          <PrimaryButton text="ยกเลิก" btnType="Cancel" onClick={onCloseDrawer} />
          <PrimaryButton text="บันทึก" onClick={onClickSave} />
        </Space>
      </Col>
    </Row>
  )

  const ConfirmSaveDailog = (
    <ConfirmDailog
      title="ยืนยันปรับสินค้าออกจากสินค้าคงคลัง"
      description={`คุณแน่ใจที่จะปรับสินค้าออกจากสินค้าคงคลังหรือไม่ ?`}
      confirmBtnTxt="ยืนยัน"
      isShow={confirmDialog}
      handleOk={onSave}
      handleCancel={() => setConfirmDialog(false)}
      loading={false}
    />
  )

  return (
    <Wrapper>
      <Row gutter={[8, 8]}>
        <Col md={6} xs={24}>
          จำนวนสินค้าที่ต้องการปรับออก
        </Col>
        <Col md={10} xs={24}>
          <AppInput
            name="adjustAmount"
            label=""
            errorMsg="จำนวนสินค้าที่ต้องการปรับออก"
            type="number"
            isRequired={isRequired('adjustAmount')}
            isError={isError('adjustAmount')}
            value={formData.adjustAmount}
            onChange={onUpdateData}
            resProps={{ suffix: uom }}
          />
        </Col>
      </Row>
      <Row gutter={[8, 16]}>
        <Col span={24}>
          <Row gutter={8}>
            <Col md={6} xs={24}>
              รูปแบบการเลือกสินค้าออกจากคลัง
            </Col>
            <Col md={10} xs={24}>
              <Radio.Group onChange={(e: RadioChangeEvent) => setAutoStock(e.target.value)} value={autoStock}>
                <Space direction="vertical" align="baseline">
                  <Radio value={true}>เลือก GRN อัตโมมัติ (FIFO)</Radio>
                  <Radio value={false}>เลือก GRN ด้วยตัวเอง</Radio>
                </Space>
              </Radio.Group>
            </Col>
          </Row>
        </Col>
        {!autoStock && (
          <Col span={24}>
            <Row gutter={8}>
              <Col md={6} xs={24}>
                <Space direction="vertical">
                  <span>เลือก GRN ที่ต้องการนำสินค้าออก</span>
                </Space>
              </Col>
              <Col md={18} xs={24}>
                <Transfer
                  dataSource={getData()}
                  titles={[
                    'เลือก GRN ที่ต้องการนำสินค้าออก',
                    <div>
                      GRN ที่ต้องการนำสินค้าออก{' '}
                      {formData.adjustAmount > 0 &&
                        (grnCount >= formData.adjustAmount ? (
                          <Success key={grnCount}>(ครบ)</Success>
                        ) : (
                          <Warning key={grnCount}>
                            (ขาดอีก {formData.adjustAmount - grnCount} {uom})
                          </Warning>
                        ))}
                    </div>,
                  ]}
                  targetKeys={targetKeys}
                  selectedKeys={selectedKeys}
                  onChange={onChange}
                  onSelectChange={onSelectChange}
                  onScroll={onScroll}
                  render={item => `${item.title} - ${item.description}`}
                  oneWay
                  listStyle={{
                    width: '100%',
                    height: 300,
                  }}
                  showSearch
                  operations={['เลือก']}
                />
              </Col>
              <Col offset={6} span={12}>
                {isError('grn') && (
                  <Warning>กรุณาเลือก GRN ให้เท่ากับหรือมากกว่าจำนวนสินค้าที่ต้องการนำออก</Warning>
                )}
              </Col>
            </Row>
          </Col>
        )}
        <Col span={24}>
          <Row gutter={8}>
            <Col md={6} xs={24}>
              เหตุผล*
            </Col>
            <Col md={10} xs={24}>
              <AppTextArea
                label=""
                errorMsg="เหตุผล"
                placeHolder="ระบุเหตุผล"
                isRequired={isRequired('reason')}
                isError={isError('reason')}
                name="reason"
                rows={2}
                value={formData.reason}
                onChange={onUpdateData}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      {FooterContent}
      {ConfirmSaveDailog}
      <EventModal
        event={[actionEvent]}
        enable={true}
        successCalback={onEventSuccess}
        errorCalback={clearEvent}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div``

const Warning = styled.span`
  font-family: ${Theme.fontFamily.medium};
  font-size: 12px;
  color: #cd0707;
`

const Success = styled(Warning)`
  color: ${Theme.colors.success};
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    productGrn: selectProductGrnList(state),
    actionEvent: selectStockActionEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(AdjustStockForm)
